import { supabase } from '@/lib/supabase';

export interface BlogPostSummary {
  id: string;
  slug: string;
  title: string;
  excerpt: string | null;
  cover_image_url: string | null;
  author: string;
  published_at: string;
  tags: string[];
  reading_time_minutes: number | null;
}

export interface BlogPost extends BlogPostSummary {
  content: string;
}

/** Fetch all published posts, newest first (without full content for list view). */
export async function fetchPublishedPosts(): Promise<BlogPostSummary[]> {
  const { data, error } = await supabase
    .from('blogposts')
    .select('id, slug, title, excerpt, cover_image_url, author, published_at, tags, reading_time_minutes')
    .eq('published', true)
    .order('published_at', { ascending: false });

  if (error) throw error;
  return data ?? [];
}

/** Fetch a single published post by slug (includes full content). */
export async function fetchPostBySlug(slug: string): Promise<BlogPost | null> {
  const { data, error } = await supabase
    .from('blogposts')
    .select('*')
    .eq('slug', slug)
    .eq('published', true)
    .maybeSingle();

  if (error) throw error;
  return data ?? null;
}
